import React from 'react';
import { MyNavbar, Classes, Faculty, Intro, AboutUs, RightsReserved, ChatWidget, Testimonials } from "./Components";
import { Container } from 'reactstrap';
import './app.css';
import './typography.css';

function App() {
  return (
    <div className='App'>
      <MyNavbar />
      <Intro />
      <Container>
        <Faculty />
        <Classes />
        <Testimonials />
        <AboutUs />
      </Container>
      <RightsReserved />
      <ChatWidget />
    </div>
  );
}

export default App;
